export * from './StaticCard';
